// 计算服务费方式
function getFee(expectPrice, discount, cgType) {
  var expectPrice = expectPrice || 0;
  var je = expectPrice / 10000
  var discount = discount || 0;
  discount = discount / 100;
  var cgType = cgType || '';
  var i = 0,
    sub1 = 0,
    sub2 = 0,
    sub3 = 0;
  while (je > 0) {
    i++;
    switch (i) {
      case 1:
        {
          if (je >= 100) {
            sub1 += 100 * 0.015;
            sub2 += 100 * 0.015;
            sub3 += 100 * 0.01
          } else {
            je -= 0;
            sub1 += je * 0.015;
            sub2 += je * 0.015;
            sub3 += je * 0.01;
            je = -1;
          }
          break;
        }
      case 2:
        {
          if (je >= 500) {
            sub1 += 400 * 0.011;
            sub2 += 400 * 0.008;
            sub3 += 400 * 0.007
          } else {
            je -= 100;
            sub1 += je * 0.011;
            sub2 += je * 0.008;
            sub3 += je * 0.007;
            je = -1;
          }
          break;
        }
      case 3:
        {
          if (je >= 1000) {
            sub1 += 500 * 0.008;
            sub2 += 500 * 0.0045;
            sub3 += 500 * 0.0055
          } else {
            je -= 500;
            sub1 += je * 0.008;
            sub2 += je * 0.0045;
            sub3 += je * 0.0055;
            je = -1;
          }
          break;
        }
      case 4:
        {
          if (je >= 5000) {
            sub1 += 4000 * 0.005;
            sub2 += 4000 * 0.0025;
            sub3 += 4000 * 0.0035;
          } else {
            je -= 1000;
            sub1 += je * 0.005;
            sub2 += je * 0.0025;
            sub3 += je * 0.0035;
            je = -1;
          }
          break;
        }
      case 5:
        {
          if (je >= 10000) {
            sub1 += 5000 * 0.0025;
            sub2 += 5000 * 0.001;
            sub3 += 5000 * 0.002;
          } else {
            je -= 5000;
            sub1 += je * 0.0025;
            sub2 += je * 0.001;
            sub3 += je * 0.002;;
            je = -1;
          }
          break;
        }
      case 6:
        {
          if (je >= 50000) {
            sub1 += 40000 * 0.0005;
            sub2 += 40000 * 0.0005;
            sub3 += 40000 * 0.0005;
          } else {
            je -= 10000;
            sub1 += je * 0.0005;
            sub2 += je * 0.0005;
            sub3 += je * 0.0005;
            je = -1;
          }
          break;
        }
      case 7:
        {
          if (je >= 100000) {
            sub1 += 50000 * 0.00035;
            sub2 += 50000 * 0.00035;
            sub3 += 50000 * 0.00035;
          } else {
            je -= 50000;
            sub1 += je * 0.00035;
            sub2 += je * 0.00035;
            sub3 += je * 0.00035;
            je = -1;
          }
          break;
        }
      case 8:
        {
          if (je >= 500000) {
            sub1 += 400000 * 0.00008;
            sub2 += 400000 * 0.00008;
            sub3 += 400000 * 0.00008;
          } else {
            je -= 100000;
            sub1 += je * 0.00008;
            sub2 += je * 0.00008;
            sub3 += je * 0.00008;
            je = -1;
          }
          break;
        }
      case 9:
        {
          if (je >= 1000000) {
            sub1 += 500000 * 0.00006;
            sub2 += 500000 * 0.00006;
            sub3 += 500000 * 0.00006;
          } else {
            je -= 500000;
            sub1 += je * 0.00006;
            sub2 += je * 0.00006;
            sub3 += je * 0.00006;
            je = -1;
          }
          break;
        }
      default:
        {
          je -= 1000000;
          sub1 += je * 0.00004;
          sub2 += je * 0.00004;
          sub3 += je * 0.00004;
          je = -1;
          break;
        }
    }
  }
  sub1 = (sub1 * 10000 * discount).toFixed(2);
  sub2 = (sub2 * 10000 * discount).toFixed(2);
  sub3 = (sub3 * 10000 * discount).toFixed(2);
  var fee = 0;
  if (cgType == '货物') {
    fee = sub1;
  }
  if (cgType == '服务') {
    fee = sub2;
  }
  if (cgType == '工程') {
    fee = sub3;
  }
  return fee
}

export { getFee }
